export default "__VITE_ASSET__CRXloAMs__"